// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:992px){.nav-mobile-menu[data-v-a9507fbe],.navbar-search-form-mobile[data-v-a9507fbe]{display:none}}", ""]);
// Exports
module.exports = exports;
